<template lang="pug">
    div: .input-group.input-group-sm.size-dropdown.float-right
      .input-group-prepend: .input-group-text.system-font Page size
      select.custom-select.system-font(:value="pagination.per_page", @change="setPageSize($event.target.value)")
        option.system-font 15
        option.system-font 20
        option.system-font 30
        option.system-font(v-if="pagination.total > 30") 50
        option.system-font(v-if="pagination.total > 50") 100
        option.system-font(v-if="pagination.total > 100" v-bind:value="pagination.total") All
</template>

<script>
export default {
  name: 'PageItems',

  props: {
    pagination: { required: true }
  },

  methods: {
    setPageSize (size) {
      this.$emit('setPageSize', Number.parseInt(size))
    }
  }
}
</script>

<style lang="sass" scoped>
  .size-dropdown
    width: 125px

  .system-font
    font-family: Arial, Helvetica, sans-serif
    font-size: 11px
</style>
